<template>

  <div>

    <!-- ALERTA DE MENSAGENS -->
    <div transition="slide-y-transition">
      <v-alert v-model="alert" dismissible outline :color="alertColor" transition="slide-y-transition">
        {{ msgAlert }}
        <v-btn v-if="companies.length < 1" small title="Recarregar" @click="initialize();" :color="alertColor" icon>
          <v-icon small>refresh</v-icon>
        </v-btn>
      </v-alert>
    </div>

    <!-- Confirmação de desativação de empresa -->
    <v-dialog v-model="desactivationDialog" persistent :overlay="true" max-width="500px" transition="dialog-transition">
      <v-card>
        <v-toolbar class="elevation-1" card>
          <v-toolbar-title class="font-weight-light">
            {{desactivationDialogTitle}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn color="error" title="Cancelar" icon round flat
              @click.stop.prevent="desactivationDialog = false, company.active = true">
              <v-icon large>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <p>{{deactivationText}}</p>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" block outline round @click="deactivateCompany">Aceitar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Edição de PDFs -->
    <v-dialog v-model="pdfWindow" :persistent="loading == false ? false : true" :overlay="false" max-width="500px"
      transition="dialog-transition">
      <v-card>
        <v-toolbar color="white" class="elevation-1" card>
          <v-toolbar-title class="black--text font-weight-light">
            {{pdfWindowTitle}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn color="error" title="Cancelar" icon round flat
              @click.stop.prevent="pdfWindow = false, editingPdf = false">
              <v-icon large>clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-text-field box v-model="pdfModel.name" label="Nome"></v-text-field>
          <v-layout row justify-center pa-3>
            <v-chip class="white--text font-weight-light" color="info" v-if="pdfModel.file && pdfName">{{pdfModel.file
              ? pdfName : pdfModel.file ? pdfModel.file :'Sem documentos'}}</v-chip>
          </v-layout>
          <v-layout row justify-center>
            <v-tooltip bottom style="width:100%">
              <v-btn slot="activator" class="white--text font-weight-light headline" label=" Enviar seus documentos"
                color="primary" round block outline @click="pickPdf">
                <v-icon>attach_file</v-icon>
              </v-btn>
              <span class="font-weight-light">Enviar arquivo (PDF)</span>
            </v-tooltip>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success lighten-1" :loading="loading" round block :disabled="disabledButtonSave"
            @click.native.prevent="savePdf(pdfModel)">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Toolbar da data table -->
    <v-toolbar flat mb-2>
      <v-toolbar-title class="font-weight-light">{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
      <v-spacer></v-spacer>
      <v-btn :disabled="loading" :loading="loading" :color="loading ? 'info' : 'info'" icon
        title="Inserir um novo registro" @click="addCompany();">
        <v-icon>add</v-icon>
      </v-btn>
      <v-dialog v-model="dialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
        <!-- :class="company && company.active != undefined || null && !isValidCnpj ? 'modal-size' : ''" -->
        <v-card v-if="loading == false">
          <v-toolbar color="white" class="elevation-1" card>
            <v-toolbar-title class="black--text font-weight-light">
              {{formTitle}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-switch class="pt-switch" pt-4 v-if="company && company.active != undefined || null && !isValidCnpj"
                :loading="loading"
                @click.prevent="company.active  == true ? desactivationDialog = true : activateCompany()"
                :label='company.active ? "Ativa" : "Inativa"' v-model="company.active"></v-switch>
              <v-btn color="error" title="Cancelar" icon round flat @click="closeDialog">
                <v-icon large>clear</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <!-- FORMULÁRIO DE CADASTRO -->
          <v-card-text>
            <v-form ref="form" lazy-validation>

              <v-container fluid grid-list-xl>
                <v-text-field box pa-3 v-model="cnpj.cnpj" label="CNPJ" mask="##.###.###/####-##"
                  placeholder="Informe o CNPJ para iniciar o cadastro" autofocus append-outer-icon="search"
                  @click:append-outer="searchCnpj" :disabled="isEditing">
                </v-text-field>
                <v-layout v-if="isValidCnpj" wrap row>
                  <!-- Informações Básicas -->
                  <v-flex xs12 py-0>
                    <v-divider></v-divider>
                    <v-subheader>Informações Básicas</v-subheader>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.socialName" label="Razão Social" required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.fantasyName" label="Nome Fantasia" required></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.socialInscription" label="Inscrição Estadual" required>
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- Endereço -->
                  <v-flex xs12 py-0>
                    <v-divider></v-divider>
                    <v-subheader>Endereço</v-subheader>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field box v-model="company.address.addressType" label="Logradouro"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field box v-model="company.address.district" label="Bairro"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.address.complement" label="Complemento"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field box v-model="company.address.number" label="Número"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field box v-model="company.address.cep" label="CEP"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.address.city" label="Município"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md2>
                        <v-text-field box v-model="company.address.state" label="UF"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.contact.email" :rules="emailRules" label="E-mail"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field box v-model="company.contact.phone" label="Telefone"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field box v-model="company.contact.fax" label="Fax"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- Representante Legal (Obrigatório) -->
                  <v-flex xs12 py-0>
                    <v-divider></v-divider>
                    <v-subheader>Representante Legal</v-subheader>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.legalRepresentative.name" :rules="inputRules" label="Nome"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.legalRepresentative.rg" :rules="inputRules" label="RG"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field box v-model="company.legalRepresentative.cpf" :rules="inputRules" label="CPF"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- Tributação  -->
                  <v-flex xs12 py-0>
                    <v-divider></v-divider>
                    <v-subheader>Tributação</v-subheader>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md3>
                        <v-autocomplete box v-model="company.taxation.taxationType" label="Tipo de Tributação"
                          :items="typesOfTributaion" :rules="taxationRules">
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md3
                        v-if="company.taxation.taxationType && company.taxation.taxationType == 'Simples Nacional'">
                        <v-text-field :rules="inputRules" box v-model="company.taxation.uniqueTaxation" type="number" label="Taxação Única">
                        </v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3
                        v-if="company.taxation.taxationType && company.taxation.taxationType != 'Simples Nacional'">
                        <v-text-field :rules="inputRules" box v-model="company.taxation.pis" type="number" label="PIS"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3
                        v-if="company.taxation.taxationType && company.taxation.taxationType != 'Simples Nacional'">
                        <v-text-field box  v-model="company.taxation.cofins" type="number" label="COFINS"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3
                        v-if="company.taxation.taxationType && company.taxation.taxationType != 'Simples Nacional'">
                        <v-text-field box :rules="inputRules" v-model="company.taxation.iss" type="number" label="ISS"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- Dados Bancários -->
                  <v-flex xs12 py-0>
                    <v-divider></v-divider>
                    <v-subheader>Dados Bancários</v-subheader>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md3>
                        <v-text-field box v-model="company.bankData.bankNumber"  :rules="inputRules" label="Número do Banco"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field box v-model="company.bankData.nameBank" :rules="inputRules" label="Nome do Banco"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field box v-model="company.bankData.agency" :rules="inputRules" label="Agência"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md3>
                        <v-text-field box v-model="company.bankData.account" :rules="inputRules" label="Conta"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- Logo -->
                  <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                    <v-container fluid>
                      <v-layout row justify-center>
                        <h1 class="font-weight-light body-1 black--text headline"> Logo </h1>
                      </v-layout>
                    </v-container>
                    <v-container fluid>
                      <v-tooltip bottom>
                        <v-avatar slot="activator" size="120" color="primary">
                          <v-img v-if="company.companyImage" height="120" @click="pickImage"
                            :src="company.companyImage">
                          </v-img>
                          <span class="white--text display-1"
                            v-else-if="company.socialName">{{company.socialName[0]}}</span>
                          <v-btn :disabled="loading" dark absolute large centered flat icon block round
                            @click="pickImage">
                            <v-icon>attach_file</v-icon>
                          </v-btn>
                        </v-avatar>
                        <span class="font-weight-light">Enviar imagem (Logo)</span>
                      </v-tooltip>
                    </v-container>
                    <v-layout row wrap justify-center class="font-weight-light black--text">
                      <v-flex xs12>
                        <v-chip v-show="imageName">{{imageName ? imageName : 'Selecione uma imagem'}}</v-chip>
                      </v-flex>
                      <v-spacer></v-spacer>
                    </v-layout>
                    <input type="file" style="display: none" ref="image" accept="image/*" @change="onImagePicked">
                  </v-flex>
                  <!-- Documentos -->
                  <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                    <!--<v-container fluid>-->
                    <v-layout row justify-center class="black--text font-weight-light headline">
                      Documentos
                    </v-layout>
                    <br>
                    <v-footer class="pa-3 elevation-1" style="border-radius: 5px;" height="auto" width="100%"
                      color="info">
                      <span class="white--text">
                        <strong>AVISO:</strong>
                        Todos arquivos enviados devem conter o formato '.pdf', caso contrário os arquivos não serão
                        aceitos!
                      </span>
                    </v-footer>
                    <br>
                    <v-layout row justify-center class="px-3 pt-3">
                      <v-tooltip bottom style="width:100%">
                        <v-btn slot="activator" class="white--text font-weight-light headline"
                          label=" Enviar seus documentos" color="primary" round block large outline @click="pickPdf">
                          E<a class="text-lowercase">nviar</a>
                          <v-icon right>attach_file</v-icon>
                        </v-btn>
                        <span class="font-weight-light">Enviar arquivos (PDF)</span>
                      </v-tooltip>
                    </v-layout>
                    <v-layout row justify-center>
                      <v-flex xs12>
                        <v-chip class="white--text font-weight-light" color="info" v-if="pdfName">{{pdfName ? pdfName :
                        'Sem documentos selecionados'}}</v-chip>
                      </v-flex>
                      <v-spacer></v-spacer>
                    </v-layout>
                    <input type="file" style="display: none" ref="pdf" accept="application/pdf" @change="onPdfPicked">
                    <v-layout row wrap v-if="company.companyDocuments">
                      <v-container fluid grid-list-md>
                        <v-data-iterator v-if="company.companyDocuments.length > 0" :items="company.companyDocuments"
                          content-tag="v-layout" row wrap hide-actions no-data-text="">
                          <v-flex slot="item" slot-scope="props" class="px-0" xs12>
                            <v-card>
                              <v-toolbar color="primary" card>
                                <v-toolbar-title class="white--text font-weight-light">{{props.item.name}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                  <v-btn v-if="props.item.name.slice(-3) == 'pdf'" color="red accent-2" disabled small
                                    round icon>
                                    <v-avatar size="30" class="font-weight-light white--text" color="red accent-2">
                                      {{props.item.name.slice(-3)}}
                                    </v-avatar>
                                  </v-btn>
                                  <v-btn color="white" icon flat round @click="openPdf(props.item.file)">
                                    <v-icon>call_made</v-icon>
                                  </v-btn>
                                  <v-btn color="teal lighten-2" icon flat round @click="editPdf(props.item)">
                                    <v-icon>edit</v-icon>
                                  </v-btn>
                                  <v-btn color="error" icon flat round @click="removePdf(props.item)">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </v-toolbar-items>
                              </v-toolbar>
                            </v-card>
                          </v-flex>
                        </v-data-iterator>
                      </v-container>
                    </v-layout>
                    <!--</v-container>-->
                  </v-flex>

                </v-layout>
              </v-container>
            </v-form>

          </v-card-text>
          <v-card-actions class="actions-padding" v-if="company.cnpj">
            <v-btn color="success lighten-1" :loading="loading" class="mx-4 mb-4" large round block
              :disabled="disabledButtonSave" @click="save();">
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <!-- TABELA DE REGISTROS -->

    <v-data-table :headers="headers" :loading="loading" :search="search" :items="companies" hide-actions
      class="elevation-1 font-weight-light">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ capitalize(props.item.socialName) }}</td>
        <td class="text-xs-center">{{ capitalize(props.item.fantasyName) }}</td>
        <td class="text-xs-center">{{ props.item.cnpj }}</td>
        <td class="text-xs-center">{{ props.item.contact.email }}</td>
        <td class="text-xs-center">{{ props.item.contact.phone }}</td>
        <td class="text-xs-center">
          <v-chip small class="white--text font-weight-light"
            :color="props.item.active == false ? 'error' : 'success lighten-1' " :disabled="props.item.active == false">
            {{props.item.active == false ? 'Inativa' : 'Ativa'}}</v-chip>
        </td>
        <td class="text-xs-center">
          <v-layout row>
            <v-btn color="info" round flat icon @click="edit(props.item)" title="Editar registro" :disabled="loading">
              <v-icon>edit</v-icon>
            </v-btn>
          </v-layout>
        </td>
      </template>
      <div slot="no-results" :value="true">
        <h3 class="text-xs-center">{{emptySearchText}} "{{ search }}".</h3>
      </div>
      <template slot="footer" v-if="records > 0">
        <td colspan="100%">
          <strong> {{ footerText }} {{ records }} </strong>
        </td>
      </template>
      <template slot="no-data" v-else>
        <strong> {{footerDynamicText}} </strong>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import CompanyService from "../service/CompanyService";
  import PersonService from "../service/PersonService";
  import Converter from "../utils/LegalPersonConverter";

  export default {
    data: () => ({
      typesOfTributaion: ["Simples Nacional", "Lucro Presumido", "Lucro Real"],
      bankData: {},

      /*********\
      *****Visual*****
        \*********/
      //Alertas e dialogos
      alert: false,
      msgAlert: "",
      alertColor: "yellow darken-2",
      dialog: false,
      pdfWindow: false,
      desactivationDialog: false,
      tabsInfo: 0,
      /**********\
      ***Rules***
      \**********/
      inputRules: [
        v => !!v || 'Campo obrigatório',
      ],
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+/.test(v) || 'Insira um e-mail válido'
      ],
      taxationRules:[
        v => !! v || 'Selecione um tipo de tributação'
      ],
      /*********\
        ***Textos**
        \*********/
      deactivationText: "Ao desativar, essa informação não poderá ser utilizada em outras áreas do sistema!",
      footerText: "Total de empresas: ",
      emptyRecordsText: "Nenhuma empresa encontrada",
      emptySearchText: "Nenhuma empresa encontrada para",
      loadingRecordsText: "Carregando empresas...",
      pdfWindowTitle: "Editar Arquivo",
      desactivationDialogTitle: "Desativar Empresa",
      companyInfoTitle: "Detalhes Sobre a Empresa",
      title: "Listagem de Empresas",
      buttonTitle: "Novo",
      /*********\
      ***Informação***
        \*********/
      records: 0,
      loading: false,
      //Botões
      disabledButtonSave: true,
      /*******************\
      ***Data Table||Recursos***
        \*******************/
      //Data Tables
      search: "",
      headers: [{
          text: "Razão social",
          align: "center",
          value: "socialName"
        },
        {
          text: "Nome fantasia",
          align: "center",
          value: "fantasyName"
        },
        {
          text: "CNPJ",
          align: "center",
          value: "cnpj"
        },
        {
          text: "E-Mail",
          align: "center",
          value: "email"
        },
        {
          text: "Telefone",
          align: "center",
          value: "phone"
        },
        {
          text: "Status",
          sortable: true,
          value: "socialName"
        },
        {
          text: "",
          sortable: false,
          value: "socialName"
        }
      ],
      //Recursos

      defaultCompany: {
        address: {},
        bankData: {},
        companyDocuments: [],
        contact: {},
        legalRepresentative: {},
        taxation: {}
      },
      company: {
        address: {},
        bankData: {},
        companyDocuments: [],
        contact: {},
        legalRepresentative: {},
        taxation: {}
      },
      companies: [],
      /******\
      ***Edição***
        \******/
      isEditing: false,
      isValidCnpj: false,
      validCnpj: {},
      cnpj: {},
      pdfModel: {},
      editingPdf: false,
      savingCompany: false,
      /********\
      ***Arquivos***
        \********/
      //Imagens
      imageName: "",
      imageUrl: "",
      //PDFs
      pdfName: "",
      pdfUrl: ""
    }),

    computed: {
      formTitle() {
        return this.company._id ? "Editar Empresa" : "Nova Empresa";
      },
      footerDynamicText() {
        let text = this.loading ? this.loadingRecordsText : this.emptyRecordsText;
        return text;
      }
    },
    created() {
      this.initialize();
    },

    watch: {
      desactivationDialog: function () {
        if (!this.company) return;
        if (!this.company.hasOwnProperty("active")) return;
        if (this.company.active == undefined || null) return;
        if (this.savingCompany == true) {
          this.desactivationDialog = false;
        }
      }
    },

    methods: {
      async searchCnpj() {
        let cnpj = await PersonService.searchCnpj(this.cnpj);
        if (cnpj) {
          this.company = Converter.getPersonConverterFrom(cnpj);
          if (this.company != {}) {
            this.isEditing = false;
            this.isValidCnpj = true;
            this.disabledButtonSave = false;
          } else return 0;
        }
      },

      showAlert(message, color) {
        this.msgAlert = message;
        this.alertColor = color;
        this.alert = true;
      },

      generateDate(_date) {
        let date = new Date(_date);
        return date.toLocaleDateString("pt-BR");
      },

      capitalize(s) {
        return s.toLowerCase().replace(/\b./g, function (a) {
          return a.toUpperCase();
        });
      },

      calculateRecords() {
        let amount = 0; //Iniciar em 0
        this.companies.forEach(v => amount++); //Para cada item nos registros aumentar em 1 (um)
        this.records = amount; //Salvar o número
      },

      closeDialog() {
        this.dialog = false;
        this.isValidCnpj = false;
        this.cnpj = {};
        this.disabledButtonSave = false;
        this.isEditing = false;
        this.savingCompany = false;
        this.company = this.defaultCompany;
      },

      async initialize() {
        if (!this.loading) this.loading = true; //Se não estiver com o visual de carregamento, o ligar
        try {
          if (this.companies.length < 1) this.alert = false;
          this.companies = await CompanyService.getAll(); //Receber os registros da API
          this.company = this.defaultCompany
          this.bankData = new Object();
          this.cnpj = new Object();
          this.pdfModel = {};
          this.editingPdf = false;
          this.search = ""; //Limpar dados
          this.dialog = false;
          this.disabledButtonSave = true;
          this.savingCompany = false;
          this.calculateRecords(); //Carregar o número de registros
          this.isValidCnpj = false;
        } catch (error) {
          //Mandar o erro
          this.showAlert("Erro ao carregar empresas!", "error");
          console.log(error);
        } finally {
          //Tirar o visual de carregamento
          this.loading = false;
        }
      },

      addCompany() {
        if (this.isValidCnpj == true) {
          this.company = this.defaultCompany;
          this.dialog = true;
          this.disabledButtonSave = false;
          this.isEditing = false;
        } else this.dialog = true;
        this.disabledButtonSave = true;
        this.isEditing = false;
      },

      edit(itemSelectEdit) {
        if (this.loading) return;
        this.cnpj.cnpj = itemSelectEdit.cnpj
        this.company = Object.assign(this.defaultCompany, itemSelectEdit); //Carregar o item a ser editado
        this.isEditing = true; //Abrir o dialogo e começar a edição
        this.isValidCnpj = true;
        this.dialog = true;
        this.disabledButtonSave = false;
      },

      async activateCompany() {
        try {
          this.desactivationDialog = false;
          this.savingCompany = true;
          this.company.active = true;
          this.dialog = false;
          await this.save();
          this.showAlert("Ativada com sucesso!", "success");
        } catch (error) {
          console.log(error);
        }
      },

      async deactivateCompany() {
        try {
          this.desactivationDialog = false;
          this.company.active = false;
          this.dialog = false;
          await this.save();
          this.showAlert("Desativada com sucesso!", "success");
        } catch (error) {
          console.log(error);
        }
      },
      async save() {
        if (this.$refs.form.validate()) {
          if (this.loading) return;
          this.loading = true;
          try {
            this.dialog = false;
            if (this.imageUrl && this.company) {
              this.company.companyImage = this.imageUrl;
            }
            if (this.company._id) {
              await CompanyService.update(this.company);
              this.msgAlert = "Alterado com sucesso!";
            } else {
              await CompanyService.save(this.company);
              this.msgAlert = "Salvo com sucesso!";
            }
            this.showAlert(this.msgAlert, "success");
          } catch (error) {
            this.showAlert("Erro ao salvar empresa!", "error");
            console.log(error);
          } finally {
            this.initialize();
          }
        }

      },
      /**********\
        * ARQUIVOS *
        \**********/
      //pdfs etc
      savePdf(pdf) {
        this.pdfWindow = false;
        let filter = this.company.companyDocuments.filter(
          document => document._id === pdf._id
        );
        let index = this.company.companyDocuments.indexOf(filter[0]);
        if (index != -1) {
          this.company.companyDocuments.splice(index, 1, pdf);
          if (this.pdfModel) {
            this.pdfModel = Object.assign({});
            this.editingPdf = false;
          }
        }
      },

      editPdf(pdf) {
        this.pdfModel = pdf;
        this.pdfWindow = true;
        this.editingPdf = true;
      },

      removePdf(pdf) {
        let index = this.company.companyDocuments.indexOf(pdf); //indexOf, não findIndex lmao
        if (index != -1 && confirm("Quer mesmo remover esse documento?")) {
          //Confirmar
          this.company.companyDocuments.splice(index, 1); //Remover o index achado pelo indexOf
        }
      },

      pickPdf() {
        this.$refs.pdf.click(); //Simular um click no elemento que tem como ref "pdf"
      },

      onPdfPicked(e) {
        if (e && e.target.files) {
          //Caso tenha enviado arquivos
          var pdfs = e.target.files; //Pegar os arquivos enviados
        } else {
          return; //Else retornar e não deixar a função continuar
        }
        if (pdfs[0] != undefined && pdfs.hasOwnProperty(0)) {
          //Se o pdf realmente tem o item 0 , melhor se previnir do que se desculpar
          this.pdfName = pdfs[0].name; //Colocar o pdfName com o nome do arquivo
          if (this.pdfName.lastIndexOf(".") <= 0) {
            //Se o arquivo não tiver um tipo
            return;
          }
          let fileReader = new FileReader(); //Ler arquivo
          if (!pdfs.hasOwnProperty(0)) return;
          fileReader.readAsDataURL(pdfs[0]); //Transformar em base64
          fileReader.addEventListener("load", () => {
            //Callback para quando terminar de dar o upload
            this.pdfUrl = fileReader.result; //Pegar o resultado do callback
            if (this.company != {} && this.editingPdf == false) {
              this.company.companyDocuments.push({
                //Inserir os documentos no registro caso não esteja em modo de edição
                name: this.pdfName,
                file: this.pdfUrl
              });
            } else if (this.editingPdf == true) {
              //Caso em modo de edição
              this.pdfModel.file = this.pdfUrl; //Deixar o pdf a ser editado com o arquivo que levou upload
            }
          });
        } else {
          this.pdfName = ""; //Else deixar tudo vazio
          this.pdfUrl = "";
        }
      },

      openPdf(pdf) {
        if (pdf && pdf != undefined && pdf != null && pdf != "") {
          //Fon
          var pdfWindow = window.open(""); //Cria a janela
          pdfWindow.document.write(
            `<iframe width='100%' height='100%' src='${encodeURI(pdf)}'></iframe>`
          ); //Abrir ela com o pdf
          pdfWindow.focus;
        }
      },

      //imagens

      pickImage() {
        this.$refs.image.click();
      },

      onImagePicked(e) {
        const files = e.target.files;
        if (files[0] !== undefined && files.hasOwnProperty(0)) {
          this.imageName = files[0].name;
          if (this.imageName.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener("load", () => {
            this.imageUrl = fr.result;
          });
        } else {
          this.imageName = "";
          this.imageUrl = "";
        }
      }
    }
  };

</script>

<style scoped>
  .style {
    border-bottom: 1px solid rgba(0, 0, 0, .1);
  }

  .actions-padding {
    padding-right: 18px;
    padding-bottom: 19px;
    padding-left: 18px;
  }

  .pt-switch {
    padding-top: 20px;
  }

  .modal-size {
    width: auto;
    height: 900px;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Company.vue